import { render, staticRenderFns } from "./demographics.vue?vue&type=template&id=cfaf726a&scoped=true&"
import script from "./demographics.vue?vue&type=script&lang=js&"
export * from "./demographics.vue?vue&type=script&lang=js&"
import style0 from "./demographics.vue?vue&type=style&index=0&id=cfaf726a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfaf726a",
  null
  
)

export default component.exports